namespace Matrix.Indexation {
    export interface IndexTypeForm {
        IndexTypeCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class IndexTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.IndexType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IndexTypeForm.init)  {
                IndexTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(IndexTypeForm, [
                    'IndexTypeCode', w0,
                    'Name', w0,
                    'DefaultSortOrder', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
